import { render, staticRenderFns } from "./BS_PlatformSetting.vue?vue&type=template&id=7a1a2fb9&scoped=true&"
import script from "./BS_PlatformSetting.vue?vue&type=script&lang=js&"
export * from "./BS_PlatformSetting.vue?vue&type=script&lang=js&"
import style0 from "./BS_PlatformSetting.vue?vue&type=style&index=0&id=7a1a2fb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1a2fb9",
  null
  
)

export default component.exports